import React from "react";
import TrimbleMapsDrawControl from "@trimblemaps/trimblemaps-draw";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import Events from "../../../../../utilities/EventEmitter";
import constant from "../../../../../lib/Map/Trimble/utils/mapconstants";
import drawConstant from "./DrawConstant";
import { compose } from "recompose";
import { withMapContext } from "../../../../../lib/Map/Trimble/components/MapContext";
class DrawingTools extends React.Component {
  constructor(props) {
    super(props);
    this.draw = null;
  }

  componentDidMount() {
    Events.on(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
      this.resetData
    );
    const { map } = this.props;
    if (this.props.map) {
      map.on("load", this.addDrawControl);
    }
  }


  addDrawControl = () => {
    //in order to rerender drawings with colors on data load/update we need to remove the draw control and add it back when data is updated
    this.draw && this.props.map.removeControl(this.draw);
    if (this.props.map) {
      this.draw = new TrimbleMapsDrawControl({
        displayControlsDefault: false,
        userProperties: true,
        styles: this.props.styleArray,
      });
      this.props.map.addControl(this.draw, "top-left");
      this.refreshDrawings();
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id ||
      this.props.geoDataList !== prevProps.geoDataList ||
      (this.props.mode && this.props.mode !== prevProps.mode)
    ) {
      const stylesUnchanged =
        JSON.stringify(this.props.styleArray) === JSON.stringify(prevProps.styleArray);
      if (this.draw && stylesUnchanged) {
        this.refreshDrawings();
      } else {
        this.addDrawControl();
      }
    }
  }

  refreshDrawings = () => {
    this.setDrawObject();
    this.addPolygon();
  };

  componentWillUnmount() {
    Events.off(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
      this.resetData
    );
     this.props.map?.off("load", this.addDrawControl);
  }

  resetData = (actionType, isExistingFeature, featureId) => {
    //this method restores the drawing to its original state when user cancels the changes.
    if (actionType === "cancel") {
      isExistingFeature ? this.handleUpdate() : this.draw.delete(featureId);
    }
  };

  handleUpdate = () => {
    this.addPolygon();
  };

  addPolygon = () => {
    const features =
      this.props.geoDataList?.length > 0 ? this.props.geoDataList : [];
    if (this.draw) {
      this.draw.set({
        type: "FeatureCollection",
        features,
      });
    }
  };

  setDrawObject = () => {
    this.props.eventHub &&
    this.props.eventHub.emit(constant.EVENT.SET_MAP_DRAW, {
        map: this.props.map,
        draw: this.draw,
        drawComplete: this.props.onDrawingComplete,
      });
  };

  render() {
    return null;
  }
}

export default compose(withUserProfile, withMapContext)(DrawingTools);
